import React, { useEffect } from 'react'
import AOS from "aos"
import "../index.scss"

import Head from "../components/Head"
import Layout from "../components/Layout"
import AboutText from "../components/AboutText"
import Skillbars from "../components/Skillbars"
import FavBooks from "../components/FavBooks"
import Parcours from "../components/Parcours"
import CV from "../assets/CV_mbf.pdf"

export default function about() {
  useEffect(() => {
    AOS.init()
  }, [])

  return (
    <>
      <Head title="A propos | Maxime BOUNAAS-FERRET" />
      <Layout>
        <AboutText />
        <Skillbars />
        <FavBooks />
        <Parcours />
        <div className="container">
          <a id="download_cv_button" href={CV} download>Télécharger mon CV</a>
        </div>
      </Layout>
    </>
  )
}
